import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import loadingReducer from "../features/auth/loadingSlice";
import interceptorReducer from "../features/auth/interceptorSlice";
import profileReducer from "../features/profile/profileSlice";
import candidateReducer from "../features/candidate/candidateSlice";
import userReducer from "../features/user/userSlice";
import roleReducer from "../features/role/roleSlice";
import lovReducer from "../features/General/lovSlice";
import candidateOperationReducer from "../features/candidate/candidateOperationSlice";
import messageReducer from "../features/message/messageSlice";
import frameworkReducer from "../features/framework/frameworkSlice";
import requirementProfileReducer from "../features/requirementProfile/requirementProfileSlice";
import complianceScoreReducer from "../features/complianceScore/complianceScoreSlice";
import frameworkAssignmentReducer from "../features/frameworkAssignment/frameworkAssignmentSlice";
import documentReducer from "../features/document/documentSlice";
import formReducer from "../features/form/formSlice";
import expiryConfigReducer from "../features/expiryConfig/expiryConfigSlice";
import metadataFieldReducer from "../features/metadataField/metadataFieldSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    loading: loadingReducer,
    interceptor: interceptorReducer,
    profile: profileReducer,
    candidate: candidateReducer,
    candidateOperation: candidateOperationReducer,
    lov: lovReducer,
    user: userReducer,
    role: roleReducer,
    message: messageReducer,
    framework: frameworkReducer,
    requirementProfile: requirementProfileReducer,
    complianceScore: complianceScoreReducer,
    frameworkAssignment: frameworkAssignmentReducer,
    document: documentReducer,
    form: formReducer,
    expiryConfig: expiryConfigReducer,
    metadataField: metadataFieldReducer,
    dashboard: dashboardReducer,
  },
});

export default store;
